import { ErrorState, Loading } from '@shared/components';
import {
  useGetAppPermissionsQuery,
  useGetAppRoleAppPermissionsQuery,
} from '@user-management/graphql';
import { useParams } from '@user-management/router';
import { useMemo } from 'react';

import { APP_PERMISSION_MAP } from '../../constants';
import { type AppOptions } from '../../types';
import { mapAppRolePermission } from '../../utils';
import { PermissionList, columns, columnsWithoutStatus } from '../permission-list';

export default function FormPermissionList() {
  const { appRoleId, app } = useParams('/roles-and-permissions/:appRoleId/permissions/:app');

  const { data: getAppPermissionsResult, loading: isLoadingAppPermission } =
    useGetAppPermissionsQuery();
  const { data: getAppRolePermissionItemsResult, loading: isLoadingAppRolePermission } =
    useGetAppRoleAppPermissionsQuery({
      variables: { appRoleId },
    });

  const appPermissions = getAppPermissionsResult?.getAppPermissions ?? [];
  const appRolePermissionItems = getAppRolePermissionItemsResult?.getAppRoleAppPermissions ?? [];

  const currentAppPermission = APP_PERMISSION_MAP[app as AppOptions] ?? [];

  const appPermissionDetails = useMemo(() => {
    if (isLoadingAppPermission || isLoadingAppRolePermission) return [];
    return mapAppRolePermission(appPermissions, appRolePermissionItems, currentAppPermission);
  }, [appPermissions, appRolePermissionItems, currentAppPermission]);

  const currentAppPermissionDetails = useMemo(
    () =>
      appPermissionDetails.filter((appPermissionDetail) =>
        currentAppPermission.includes(appPermissionDetail.id),
      ),
    [appPermissionDetails, currentAppPermission],
  );

  if (isLoadingAppPermission || isLoadingAppRolePermission) return <Loading />;

  switch (app) {
    case 'exam-management':
    case 'user-management':
      return (
        <PermissionList appPermissionDetails={currentAppPermissionDetails} columns={columns} />
      );
    case 'exam-center':
    case 'reports':
      return (
        <PermissionList
          appPermissionDetails={currentAppPermissionDetails}
          columns={columnsWithoutStatus}
        />
      );
    default:
      return <ErrorState />;
  }
}
